import styled from '@emotion/styled';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

export const WarehouseTransferReceiptForm = ({ onSubmit, onBack }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axiosClient
      .get('ThirdParty/HakaranSystem/Rahkaran/Stores')
      .then(res => {
        if (res.status === 200) {
          setStores(res.data?.value ?? []);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  }, [enqueueSnackbar]);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 120,
          minWidth: 300,
        }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!stores.length) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          pt: 1,
          minWidth: 300,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          انباری یافت نشد
        </Typography>
        {onBack ? (
          <Button onClick={onBack} variant="contained">
            بازگشت
          </Button>
        ) : null}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
        pt: 1,
        minWidth: 300,
        maxHeight: 360,
        overflowY: 'auto',
      }}
    >
      {stores.map(store => (
        <OptionButton
          key={store.key}
          fullWidth
          onClick={() =>
            onSubmit?.({
              storeID: Number.parseInt(store.key, 10),
            })
          }
        >
          {store.value}
        </OptionButton>
      ))}
      {onBack ? (
        <Button onClick={onBack} variant="contained" sx={{ mt: 1 }}>
          بازگشت
        </Button>
      ) : null}
    </Box>
  );
};

const OptionButton = styled(Button)`
  background-color: #e8e8e8;
  color: #333;
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 500;
  box-shadow: none;

  &:hover {
    background-color: #dcdcdc;
    box-shadow: none;
  }
`;
